<template>
  <div>
    <vx-card title="Заказ" class="p-6 mb-5">
      <div class="vx-row flex-wrap">
        <div class="vx-col flex-1">
          <table v-if="order">
            <tr>
              <td class="font-semibold">Дата доставки</td>
              <td class="pl-4 py-1">
                <span class="text-primary">{{ order.date_predicted }}</span>
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Статус доставки</td>
              <td class="pl-4 py-1">
                <vs-chip v-if="order.is_delivered" color="success"
                  >Доставлен</vs-chip
                >
                <vs-chip v-else color="danger">Не доставлен</vs-chip>
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Статус оплаты</td>
              <td class="pl-4 py-1">
                <vs-chip v-if="order.is_paid" color="success">Оплачен</vs-chip>
                <vs-chip v-else color="danger">Не оплачен</vs-chip>
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Сумма заказа</td>
              <td class="pl-4 py-1">
                <span class="text-primary">{{ order.price }} руб.</span>
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Тип доставки</td>
              <td class="pl-4 py-1">
                <span class="text-primary">{{ order.kind.name }}</span>
              </td>
            </tr>
            <tr v-if="order.comment">
              <td class="font-semibold">Комментарий</td>
              <td class="pl-4 py-1">
                <span class="text-primary">{{ order.comment }}</span>
              </td>
            </tr>
          </table>
        </div>

        <div class="vx-col flex-1">
          <table v-if="order">
            <tr>
              <td class="font-semibold">ФИО</td>
              <td class="pl-4">
                <span class="text-primary">{{ order.user.full_name }}</span>
              </td>
            </tr>
            <tr v-for="(home, index) in order.user.homes" :key="index">
              <td class="font-semibold">Адрес:</td>
              <td class="pl-4">
                <span class="text-primary"
                  >{{ home.county_type.name }}, участок #{{
                    home.homestead_number
                  }}, ул. {{ home.address }}</span
                >
              </td>
            </tr>
          </table>
        </div>
      </div>
      <template slot="footer">
        <vs-button
          v-if="order && !order.is_delivered"
          @click="changeOrderStatus"
          class="mr-3"
          color="success"
        >
          Доставлено
        </vs-button>
        <vs-button @click="popupDeleteComfirm = true" color="danger">
          Удалить
        </vs-button>
      </template>
    </vx-card>

    <vx-card title="Товары" class="p-6">
      <template v-if="order && order.products.length > 0">
        <vs-list>
          <vs-list-item
            v-for="(product, index) in order.products"
            :key="index"
            :title="`${product.product.name} x${product.quantity}`"
            :subtitle="`Цена: ${product.product.price} руб. Вес: ${product.product.weight} кг.`"
          >
            <template slot="avatar">
              <vs-avatar :src="BASE_URL + product.product.image" />
            </template>
          </vs-list-item>
        </vs-list>
      </template>
      <template v-else> В заказе отсутствуют товары </template>
    </vx-card>

    <vs-popup
      v-if="order"
      title="Вы действительно хотите удалить?"
      :active.sync="popupDeleteComfirm"
    >
      <p class="font-semibold mb-5">
        Заказ
        <span class="text-danger text-lg">#{{ order.id }}</span>
        будет удален безвозвратно
      </p>
      <vs-button @click="deleteOrder" color="danger" class="mr-5" type="filled"
        >Удалить</vs-button
      >
      <vs-button @click="popupDeleteComfirm = false" color="dark" type="border"
        >Отмена</vs-button
      >
    </vs-popup>
  </div>
</template>
<script>
import { API_URL, deliveryType, countyType } from "@/.env";
import { DateTime } from "luxon";

export default {
  data: () => ({
    BASE_URL: API_URL,
    order: null,
    popupDeleteComfirm: false,
  }),
  components: {
    DateTime,
  },
  watch: {},
  computed: {},
  methods: {
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    getOrder() {
      this.$vs.loading();

      this.$load(async () => {
        let res = (await this.$api.market.getOrder(this.$route.params.id)).data;

        res.date_predicted = DateTime.fromISO(
          res.date_predicted
        ).toLocaleString(DateTime.DATETIME_SHORT);

        res.kind = deliveryType.find((x) => x.id == res.kind);

        res.user.homes.forEach((home) => {
          home.county_type = countyType.find((x) => x.id == home.county_type);
        });

        this.order = res;
        this.$vs.loading.close();
      });
    },
    deleteOrder() {
      this.$load(async () => {
        await this.$api.market
          .deleteOrder(this.$route.params.id)
          .then((response) => {
            if (response.status == 200) {
              this.popupDeleteComfirm = false;
              this.notification("Успешно", "Заказ удален", "success");
              this.$router.push({ name: "market-orders" });
            } else {
              this.notification("Ошибка", "Не удалось удалить заказ", "danger");
            }
          });
      });
    },
    changeOrderStatus() {
      this.$load(async () => {
        await this.$api.market
          .updateOrderStatus(this.$route.params.id)
          .then((response) => {
            if (response.status == 200) {
              this.notification("Успешно", "Заказ доставлен", "success");
              this.order.is_delivered = true;
            } else {
              this.notification(
                "Ошибка",
                "Не удалось обновить статус заказа",
                "danger"
              );
            }
          });
      });
    },
  },
  mounted() {
    this.getOrder();
  },
};
</script>